import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companySupplier = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/suppliers',

        branches: [],
        branchesLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches,
    },
};
